import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  padding-top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  flex: 1;
  padding-bottom: 64px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: calc(100vw - 256px);
`;

export const ContentInner = styled.div`
  overflow: auto;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
`;

export const Footer = styled.div`
  min-height: 60px;
  align-items: center;
  display: flex;
  padding: 0 20px;
`;
